module.exports = __webpack_public_path__ + "img/icon-user.0d72032a.svg";